module.exports = __webpack_public_path__ + "appWorker.worker.js"